import { tv } from "../../variants/tv.js";
const highlightVariants = tv({
    slots: {
        highlightSlot: 'w-fit rounded-[0.25em]',
        childrenSlot: 'box-decoration-clone transition'
    },
    variants: {
        palette: {
            neutral: {},
            benefit: {},
            urgency: {},
            caution: {}
        },
        emphasis: {
            regular: '',
            medium: '',
            bold: ''
        }
    },
    compoundVariants: [
        {
            palette: 'neutral',
            emphasis: 'medium',
            class: {
                highlightSlot: 'bg-neutral-3 shadow-[0.16em_0_0_var(--color-neutral-3),-0.16em_0_0_var(--color-neutral-3)]',
                childrenSlot: 'text-neutral-11'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'medium',
            class: {
                highlightSlot: 'bg-benefit-3 shadow-[0.16em_0_0_var(--color-benefit-3),-0.16em_0_0_var(--color-benefit-3)]',
                childrenSlot: 'text-benefit-11'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'medium',
            class: {
                highlightSlot: 'bg-urgency-3 shadow-[0.16em_0_0_var(--color-urgency-3),-0.16em_0_0_var(--color-urgency-3)]',
                childrenSlot: 'text-urgency-11'
            }
        },
        {
            palette: 'caution',
            emphasis: 'medium',
            class: {
                highlightSlot: 'bg-caution-3 shadow-[0.16em_0_0_var(--color-caution-3),-0.16em_0_0_var(--color-caution-3)]',
                childrenSlot: 'text-caution-11'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'regular',
            class: {
                highlightSlot: 'bg-neutral-1 shadow-[0.16em_0_0_var(--color-neutral-1),-0.16em_0_0_var(--color-neutral-1)]',
                childrenSlot: 'text-neutral-11'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'regular',
            class: {
                highlightSlot: 'bg-benefit-1 shadow-[0.16em_0_0_var(--color-benefit-1),-0.16em_0_0_var(--color-benefit-1)]',
                childrenSlot: 'text-benefit-11'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'regular',
            class: {
                highlightSlot: 'bg-urgency-1 shadow-[0.16em_0_0_var(--color-urgency-1),-0.16em_0_0_var(--color-urgency-1)]',
                childrenSlot: 'text-urgency-11'
            }
        },
        {
            palette: 'caution',
            emphasis: 'regular',
            class: {
                highlightSlot: 'bg-caution-1 shadow-[0.16em_0_0_var(--color-caution-1),-0.16em_0_0_var(--color-caution-1)]',
                childrenSlot: 'text-caution-11'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'bold',
            class: {
                highlightSlot: 'bg-neutral-8 shadow-[0.16em_0_0_var(--color-neutral-8),-0.16em_0_0_var(--color-neutral-8)]',
                childrenSlot: 'text-neutral-1'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'bold',
            class: {
                highlightSlot: 'bg-benefit-8 shadow-[0.16em_0_0_var(--color-benefit-8),-0.16em_0_0_var(--color-benefit-8)]',
                childrenSlot: 'text-benefit-1'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'bold',
            class: {
                highlightSlot: 'bg-urgency-8 shadow-[0.16em_0_0_var(--color-urgency-8),-0.16em_0_0_var(--color-urgency-8)]',
                childrenSlot: 'text-urgency-1'
            }
        },
        {
            palette: 'caution',
            emphasis: 'bold',
            class: {
                highlightSlot: 'bg-caution-7 shadow-[0.16em_0_0_var(--color-caution-7),-0.16em_0_0_var(--color-caution-7)]',
                childrenSlot: 'text-caution-11'
            }
        }
    ],
    defaultVariants: {
        palette: 'neutral',
        emphasis: 'medium'
    }
});
const highlightPalettes = Object.keys(highlightVariants.variants.palette);
const highlightEmphases = Object.keys(highlightVariants.variants.emphasis);
export { highlightEmphases, highlightPalettes, highlightVariants };
